import {css} from '@emotion/css';
import Assert from 'Common/Assert';
import {Urls} from 'Common/Urls';
import {EditorOptions} from 'hugerte';

function style()
{
	return css({
		'.tox.tox': {
			'.tox-statusbar__branding': {
				width: 0,
				overflow: 'hidden',
			},

			'.tooManyCharacters': {
				color: 'red'
			},
		}
	});
}

//TODO bundle in using Rollup. Only want in the backend though as it is largish I think (dynamic load is also possible).

export class HtmlEditorWidget
{
	private loaded:boolean = false;

	constructor(
		private urls:Urls,
		private settings:EditorOptions
	)
	{
		this.loadHugeRte = this.loadHugeRte.bind(this);
		this.initHugeRteInstance = this.initHugeRteInstance.bind(this);
	}	

	init(anchorNode:HTMLElement)
	{
		setTimeout(async () => {
			await this.loadAndInitHugeRteInstance(anchorNode);
		},1);
	}

	private async loadAndInitHugeRteInstance(anchorNode:HTMLElement)
	{
		if (!this.loaded) {
			await this.loadHugeRte();
			this.loaded = true;
		}
		this.initHugeRteInstance(anchorNode);
	}

//TODO cleaner to use Solid
	private async loadHugeRte()
	{
		await new Promise((resolve,reject) => {
			const script = document.createElement('script');
			script.id = 'hugerteScript';
			script.addEventListener('load',() => resolve(null),false);
			script.src = this.urls.buildUrl('resources/hugerte/hugerte.min.js');
			document.body.appendChild(script);
		});
	}

	private initHugeRteInstance(anchorNode:HTMLElement)
	{
		anchorNode.classList.add(style());

		const maxChars = this.settings.maxCharacters;

		/* Note that if used in a repeater the anchor ID might well be reused */
		this.destroy(anchorNode);

		const s = { ...this.settings,
			selector: '#'+this.escapeSelector('hugerte-'+anchorNode.id),
			setup: (editor:any) => {
				if (this.settings.setup)
					this.settings.setup(editor);

				editor.on('Change', (e:any) => {
					(<any>anchorNode).value = editor.getContent();
					anchorNode.dispatchEvent(new CustomEvent('change'));
				});

				if (maxChars!=undefined) {
					editor.on('PostRender', (e:any) => {
						const rightContainer = Assert.have(editor.editorContainer.querySelector('.tox-statusbar__right-container'));
						const counterNode = document.createElement('span')
						counterNode.className = 'htmlEditorCounter';
						rightContainer.insertBefore(counterNode,rightContainer.firstChild);
					});
					editor.on('input', (e:any) => {
						const counterSpan = <HTMLSpanElement>Assert.htmlElement(editor.editorContainer.querySelector('.htmlEditorCounter'));
						this.characterMessage(counterSpan,editor.getContent().length,maxChars);
					});
					editor.on('LoadContent', (e:any) => {
						const counterSpan = <HTMLSpanElement>Assert.htmlElement(editor.editorContainer.querySelector('.htmlEditorCounter'));
						this.characterMessage(counterSpan,editor.getContent().length,maxChars);
					});
				}
			}
		};

		/* 
			HACKY. Multiple editors wont appear in Contacts > General without this.
			Perhaps the DOM-diffing is still modifying the DOM? Or perhaps multiple instances don't like
			initialising simultaneously.
			NB 1ms is not enough with so many editors on the page.
		 */
		setTimeout(() =>(<any>window).hugerte.init(s),100);
	}

	destroy(anchorNode:HTMLElement)
	{
		const id = (<any>window)?.hugerte?.get('hugerte-'+anchorNode.id);
		id?.remove();
	}

	private characterMessage(span:HTMLSpanElement,numChars:number,maxChars:number)
	{
		span.innerHTML = `${numChars} characters used (max ${maxChars})`;

		if (numChars <= maxChars)
			span.classList.remove('tooManyCharacters');
		else
			span.classList.add('tooManyCharacters');
	}

	private escapeSelector(s:string)
	{
		return s
			.replaceAll('{', '\\{')
			.replaceAll('}', '\\}')
			.replaceAll('[', '\\[')
			.replaceAll(']', '\\]')
			.replaceAll(',', '\\,')
			.replaceAll('"', '\\"')
			.replaceAll(':', '\\:');
	}
}

